<template>
  <v-navigation-drawer
    v-if="isBillingDetailOpen"
    :value="isBillingDetailOpen"
    @input="inputBillingDetail"
    :width="'65%'"
    temporary
    fixed
    right
    color="grey lighten-3"
    style="transition: 0.5s cubic-bezier(0.4, 0, 0.2, 1); padding-top: 65px;"
  >
    <div class="pt-4 pb-6">
      <v-btn text ref="button-toolbar-close" @click="closeBillingDetail">
        <v-icon>close</v-icon>
        <span>{{ $t('general.close') }}</span>
      </v-btn>
    </div>
    <div class="pa-4">
      <v-card class="pa-4 rounded-lg custom_card" flat>
        <v-card-title class="d-flex justify-center">
          <span class="title font-weight-medium">
            Detalles de facturación
          </span>
        </v-card-title>
        <v-card-text>
          <v-row
            v-for="(info, index) in formattedInformation.license"
            :key="index"
          >
            <v-col class="d-flex justify-center">
              <span class="body-2 font-weight-medium" style="color: #2661ff;">
                {{ info.label }}
              </span>
            </v-col>
            <v-col class="d-flex justify-center">
              <span class="body-2">
                {{ info.value }}
              </span>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text>
          <v-card
            v-for="(services, index) in formattedInformation.services"
            :key="index"
            class="rounded-xl custom_card pa-4"
            flat
          >
            <v-row v-for="(service, index) in services" :key="index">
              <v-col class="d-flex justify-center">
                <span class="body-2 font-weight-medium" style="color: #2661ff;">
                  {{ service.label }}
                </span>
              </v-col>
              <v-col class="d-flex justify-center">
                <span class="body-2 text-center" style="color: #6b6b6b;">
                  {{ service.value }}
                </span>
              </v-col>
            </v-row>
          </v-card>
        </v-card-text>
      </v-card>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { mapMutations, mapState } from 'vuex'

export default {
  name: 'BillingDetail',
  data() {
    return {}
  },
  computed: {
    ...mapState({
      billingDetail: ({ billings: { billingDetail } }) => billingDetail,
      isBillingDetailOpen: ({ billings: { isBillingDetailOpen } }) =>
        isBillingDetailOpen
    }),
    formattedInformation() {
      const { billingDetail } = this

      const services = billingDetail.billingServices.map(service => {
        return [
          {
            label: 'Nombre del servicio',
            value: service.display_name
          },
          {
            label: 'Costo por unidad',
            value: `${billingDetail.currency.symbol} ${service.cost}`
          },
          {
            label: 'Total del servicio',
            value: `${billingDetail.currency.symbol} ${service.pivot.amount}`
          },
          {
            label: 'Información relacionada',
            value: service.pivot.info
          }
        ]
      })

      return {
        license: [
          {
            label: 'Monto',
            value: `${billingDetail.currency.symbol} ${billingDetail.amount}`
          },
          {
            label: 'Mes de facturación',
            value: this.$moment(billingDetail.billing_date).format('MM/YYYY')
          },
          {
            label: 'Porcentaje de comisión',
            value: `${billingDetail.fee_percentage}%`
          },
          {
            label: 'Total',
            value: `${billingDetail.currency.symbol} ${billingDetail.total}`
          },
          {
            label: 'Total en USD',
            value: `${billingDetail.currency.symbol} ${billingDetail.total_usd}`
          },
          {
            label: 'Ingresos',
            value: `${billingDetail.currency.symbol} ${billingDetail.incomes_amount}`
          },
          {
            label: 'Facturación manual',
            value: billingDetail.is_manual ? 'Sí' : 'No'
          },
          {
            label: 'Plan de licencia',
            value: billingDetail.plan.display_name
          }
        ],
        services
      }
    }
  },
  methods: {
    ...mapMutations({
      setBillingDetail: 'billings/setBillingDetail',
      toggleBillingDetail: 'billings/toggleBillingDetail'
    }),
    inputBillingDetail(arg) {
      if (!arg) {
        this.closeBillingDetail()
      }
    },
    closeBillingDetail() {
      this.setBillingDetail({})
      this.toggleBillingDetail(false)
    }
  }
}
</script>

<style lang="scss" scoped></style>
